import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "transport" }
const _hoisted_2 = { class: "searchStations" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "stationName" }
const _hoisted_6 = { class: "stationNumber" }
const _hoisted_7 = { class: "names" }
const _hoisted_8 = { class: "from" }
const _hoisted_9 = { class: "to" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadTrips()))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_InfinityScroll, {
      onLoadNextPage: _ctx.loadTrips,
      data: _ctx.trips,
      class: "mainLines"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trips.data, (trip) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: { name: 'LinesById', params: { id: trip.id } },
            class: "flex customTabLink",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sidebar-toggled'))),
            key: trip.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(trip.route.short_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getHeadSignPart(trip.headsign, 0)), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getHeadSignPart(trip.headsign, 1)), 1)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoadNextPage", "data"])
  ]))
}